module.exports = __webpack_public_path__ + "static/media/hoodie-front-min.67f64beb.png";